export const FETCH_REPORTINGS = 'reportings/FETCH_REPORTINGS'
export const CLEAR_REPORTINGS_STATE = 'reportings/CLEAR_REPORTINGS_STATE'
